'use strict';

var ComponentPrototype = require('./prototype'),
    classGenerator = require('../utils/class-generator'),
    assign = require('../utils/assign'),
    merge = require('../utils/merge'),
    extendStrategies;

extendStrategies = {
    extend: assign,
    extendByMerge: merge
};

/**
 * Generates a Component Class by extending the basic ComponentPrototype
 *
 * @param {object} prototype
 * @returns {*}
 */
module.exports = function createComponent(prototype) {
    return classGenerator(extendStrategies, 'extend', ComponentPrototype, prototype);
};
